<template>
  <AmInput
    v-model="localValue"
    v-mask="documentMask"
    v-bind="amInputProps"
    @input="handleInput"
  />
</template>

<script>
import replaceSpecialCharactersMixin from '@/components/mixins/replaceSpecialCharactersMixin'
import { mapGetters } from 'vuex'
import validateDocumentMixin from '@/components/mixins/validateDocumentMixin'

export default {
  name: 'DocumentInput',
  mixins: [validateDocumentMixin, replaceSpecialCharactersMixin],
  props: {
    value: {
      type: String,
      default: '',
    },
    isPaymentCardStep: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localValue: this.value,
      placeholder: '___.___.___-__',
    }
  },
  computed: {
    ...mapGetters('Cart', ['getStoreAllowCnpj']),
    amInputProps() {
      return {
        testName: 'document',
        class: 'input--custom',
        label: this.documentLabel,
        placeholder: this.placeholder,
        validityState: this.statusDocumentValidate,
        secondaryLabel: this.textDocumentValidate,
        type: 'tel',
      }
    },
    documentLabel() {
      return this.getStoreAllowCnpj
        ? this.$t('steps.payment.card.document')
        : this.$t('steps.payment.billet.cpf')
    },
    documentMask() {
      return this.getStoreAllowCnpj ? ['###.###.###-##', '##.###.###/####-##'] : '###.###.###-##'
    },
    sanitizedDocument() {
      const document = this.localValue || ''
      return this.removeSpecialCharaters(document)
    },
  },
  watch: {
    value(newValue) {
      this.localValue = newValue
    },
  },
  methods: {
    handleInput(event) {
      this.checkDocument()
      return this.$emit('input', event)
    },
    async checkDocument() {
      return this.$emit('validate', await this.validateDocument(!this.isPaymentCardStep))
    },
  },
}
</script>
